module.exports = __webpack_public_path__ + "static/images/components/UpgradeEffect/images/hover-tile.e4da9181.png";


//////////////////
// WEBPACK FOOTER
// ./components/UpgradeEffect/images/hover-tile.png
// module id = 2694
// module chunks = 11